// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"737c3139b3169fa2","7038":"87cde24818493ef1"}[chunkId] + ".css";
};